var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumbleiconsUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0365 7.71702V18M10.0365 7.71702L13.3978 11.1447M10.0365 7.71702L6.67522 11.1447M16.1989 13.4298C17.9009 13.4298 19 12.0233 19 10.2878C18.9999 9.60066 18.779 8.93251 18.371 8.38565C17.9631 7.8388 17.3906 7.4434 16.7412 7.26C16.6413 5.97858 16.1205 4.76897 15.263 3.82674C14.4055 2.8845 13.2614 2.26472 12.0158 2.06758C10.7701 1.87045 9.49565 2.1075 8.39844 2.74039C7.30123 3.37329 6.44542 4.36504 5.96935 5.55531C4.96704 5.27198 3.89541 5.40629 2.9902 5.92868C2.08499 6.45107 1.42036 7.31876 1.14252 8.34086C0.864679 9.36296 0.996383 10.4557 1.50866 11.3788C2.02094 12.3019 2.87183 12.9796 3.87414 13.263",
    stroke: "#565A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumbleiconsUpload);
export default __webpack_public_path__ + "static/media/humbleicons_upload.a70b5f9fae17bff1accbbc5f44cbf07e.svg";
export { ForwardRef as ReactComponent };